// Must stay the first import: see the module.
import "@/lib/authCallbackBoot";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { CHUNK_RELOAD_STORAGE_KEY, claimReload } from "@/lib/deployRecovery";
import { registerPwa } from "@/lib/registerPwa";
import { watchViewportGap } from "@/lib/iosViewportGap";

// A deploy can remove the chunk this page still imports. Reload once so the
// new HTML loads. The timestamp stops a loop when the failure survives the
// refresh. https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  if (
    claimReload(window.sessionStorage, CHUNK_RELOAD_STORAGE_KEY, Date.now())
  ) {
    window.location.reload();
  }
});

registerPwa();
// iOS standalone strip below the layout viewport (WebKit 313800).
watchViewportGap();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
